import React, { useContext } from 'react';
import { Button, CallOut, CallToAction, convertGhostHTMLToReactComponents, Grid, Grid2, GridItem } from '@riac/design-system';
import { usePrefetchSuspense } from 'src/lib/usePrefetch';
import { getSlug } from 'src/lib/getSlug';
import { Page404 } from 'src/pages/Page404';
import { GhostDocDangerouslyRender } from 'src/components/GhostDocDangerouslyRender/GhostDocDangerouslyRender';
import { useBackendApiFetch } from 'src/lib/BackendFetchContext';
import { HeadContext } from 'src/lib/HeadContext';
import { RecentEventsView } from 'src/components/RecentEventsView/RecentEventsView';
import { GenericPageHeader } from 'src/components/GenericPageHeader';
import { ConsignmentLearnMoreCTA } from 'src/components/CallToAction/ConsignmentLearnMoreCTA';

export const GhostPages = ({ children, ...props }) => {
  const backendApiFetch = useBackendApiFetch();
  const head = useContext(HeadContext);
  const slug = getSlug(props);

  const pageData = usePrefetchSuspense(`ghostpages-getpagebyslug-${slug}`, async () => {
    const response = await backendApiFetch(`/api/ghost/getPageBySlug/${encodeURIComponent(slug)}`, {
      credentials: 'include',
    });
    const result = await response.json();
    try {
      result.docs.html = encodeURIComponent(result?.docs?.html);
    } catch (e) {}
    return result;
  });
  const page = pageData.read();

  if(page && !page?.success) return children || <Page404/>;
  if(head.isHead) {
    return <>
      <title>{page?.docs?.title}</title>
      <meta name='description' content={page?.docs?.meta_description || page?.docs?.custom_excerpt || page?.docs?.excerpt}/>
      <meta property='og:title' content={page?.docs?.title}/>
      <meta property='og:description' content={page?.docs?.meta_description || page?.docs?.custom_excerpt || page?.docs?.excerpt}/>
      <meta property='og:image' content={page?.docs?.image}/>
      <meta property='og:type' content='article'/>
    </>
  };

  let content = '';
  try {
    content = decodeURIComponent(page.docs.html);
  } catch (e) {}

  return (<>
    <GenericPageHeader
      title={page?.docs?.title}
      breadcrumbs={[
        { text: page?.docs?.title, slug: `/${page?.docs?.slug}` },
      ]}
      description={page?.docs?.custom_excerpt}
    />
    <Grid2 className='py-20'>
      <div className='prose max-w-[794px] text-text'>
        {convertGhostHTMLToReactComponents(content)}
      </div>
    </Grid2>
    <Grid2 className='py-20' innerContainerClassName='flex flex-col gap-10'>
      <RecentEventsView/>
      <div className='flex justify-center w-full'>
        <Button variant='secondary' to='/news-and-events'>View All Posts</Button>
      </div>
    </Grid2>
    <ConsignmentLearnMoreCTA />
  </>);
};

export default GhostPages;